export default __webpack_public_path__ + "static/Visiomate_NetAtlantic_Case_Study-f77ba8ad6258c3435c7a9982995d5ce5.pdf";